
import img1 from './alien_first.png';
import img2 from './alien_sec.png';
import './imgAlienstyle.css'

const ImgAlien = ()=>{
    return <><section className='alienImage'><img src={img1} alt="alien_image" className='firstImg'/><img src={img2} alt="alien_image2" className='secImg'/></section></>

}

export default ImgAlien